goog.provide('el8.appanalytics.reports.muPopulation');

goog.require('el8.appanalytics.dialog.bulkLetters');
// These next 2 are required so they will be included in the bundle and React code can access it
goog.require('el8.appanalytics.dialog.bulkLettersPatientList');
goog.require('el8.appanalytics.dialog.bulkLettersHandouts');
goog.require('el8.appanalytics.dialog.patientListCSV');
goog.require('el8.appanalytics.ReportTab');
goog.require('el8.appanalytics.util');
goog.require('el8.appshared.listeditorOpts');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.base');
goog.require('el8.data.currUser');
goog.require('el8.service.tooltip');
goog.require('el8.service.urls');
goog.require('el8.template.appanalytics.reports.muPopulation');
goog.require('el8.template.mindreader');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.util.consts');
goog.require('el8.util.validate');

/**
 * This file manages the patient list report (which no longer has "MU"
 * anywhere in its name but got its start as the "MU Population Report")
 *
 * To add a new filter to the UI, you need to modify four things:
 *  1. the Soy template that renders the page (appanalytics.reports.muPopulation.html)
 *  2. the fields list in formSpec
 *  3. constructQuery (to add the filter to the list sent to the server)
 *  4. prepareFiltersForDisplay (to add the filter to the result string shown to the user)
 */
el8.appanalytics.reports.muPopulation.create = function() {

    var LIMIT = 100;
    var orderBy = null,
        page = 0;

    var container = $('#mu-population-section');
    $('#mu-population-form', container).html(
        el8.template.appanalytics.reports.muPopulation.filters({
            physicianUsers: el8.data.practiceUsers.getPhysicianUsers(),
            languages: el8.data.languages.getPrioritizedMaps(),
            races: el8.data.races,
            ethnicities: el8.data.ethnicities,
            hccScoringEnabled: el8.data.practiceSettings.isHccScoringEnabled()
        })
    );

    var multifieldSpecs = [
        {
            groupName: 'labs',
            listContainer: $('#mu-population-lab-tests-list'),
            templateFn: el8.template.appanalytics.reports.muPopulation.labTestSelect,
            templateArgs: { labTests: el8.data.analyticsLabs },
            fieldSpecFn: function(index) {
                var fields = [
                    {
                        name: 'labTestName_'+index
                    },
                    {
                        name: 'labTestOperator_'+index
                    },
                    {
                        name: 'labTestValue_'+index,
                        infoText: 'value...'
                    }
                ];
                return fields;
            },
            getEntryMapFn: function(mle, index) {
                return {
                    name: mle.getVal('labTestName', index),
                    operator: mle.getVal('labTestOperator', index),
                    value: mle.getVal('labTestValue', index)
                };
            }
        }
    ];
    multifieldSpecs.push(
        getNegatableMultifieldOpts({
            groupName: 'problems',
            mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.imos('icd9'), {
                modifyRenderCb: function(cb_args) {
                    addInstructionsToInfoDiv(cb_args);

                    if (cb_args.numMatches && cb_args.infoDiv.is(':visible')) {
                        // show the HCC header if flag on
                        var tmpl = null;
                        if (el8.data.practiceSettings.isHccScoringEnabled()) {
                            tmpl = el8.template.appshared.imo.termListHeaderWithHCC;
                        } else {
                            tmpl = el8.template.appshared.imo.termListHeader;
                        }
                        cb_args.mrSections[0].prepend(tmpl({mindreader: true}));
                    }

                },
                formatSelected: function(item) {
                    if (item.imo_code) {
                        return item.icd9;
                    } else {
                        return item.code;
                    }
                }
            })
        })
    );
    multifieldSpecs.push(
        getNegatableMultifieldOpts({
            groupName: 'medications',
            mindreaderOpts: {
                url: '/s/search/medication-brands/',
                modifyRenderCb: addInstructionsToInfoDiv,
                formatResult: function(item) {
                    return item.brandName;
                },
                formatSelected: function(item) { return item.brandName; }
            }
        })
    );
    multifieldSpecs.push(
        getNegatableMultifieldOpts({
            groupName: 'allergies',
            mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.allergies(), {
                newMindreader: true,
                modifyRenderCb: addInstructionsToInfoDiv
            })
        })
    );
    multifieldSpecs.push(
        getNegatableMultifieldOpts({
            groupName: 'vaccines',
            mindreaderOpts: {
                url: function() { return el8.service.urls.get('searchVaccines'); },
                formatResult: function(item) {
                    if (item.cdc_name) {
                        return el8.template.mindreader.commonVaccine({item: item});
                    }
                    return el8.template.mindreader.otherVaccine({item: item});
                },
                containerWidth: 450,
                modifyRenderCb: addInstructionsToInfoDiv,
                formatSelected: function(item) {
                    return item.packaged_name || item.name; //use packaged name if one exists
                },
                newMindreader: true
            }
        })
    );
    multifieldSpecs.push(
        getNegatableMultifieldOpts({
            groupName: 'tags',
            mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.availablePtTags(), {
                minQueryLength: 1,
                modifyRenderCb: addInstructionsToInfoDiv,
                newMindreader: true,
                showOnFocus: true
            })
        })
    );
    multifieldSpecs.push(
        getNegatableMultifieldOpts({
            groupName: 'doctags',
            mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.codedDocumentTags(), {
                minQueryLength: 1,
                modifyRenderCb: addInstructionsToInfoDiv,
                newMindreader: true,
                showOnFocus: true
            })
        })
    );

    multifieldSpecs.push(
        getNegatableDateRangeMultifieldOpts({
            groupName: 'cptcodes',
            mindreaderOpts: $.extend(el8.appshared.mindreaderOpts.cptCodes(), {
                minQueryLength: 1,
                modifyRenderCb: addInstructionsToInfoDiv,
                newMindreader: true,
                showOnFocus: true
            })
        })
    );

    var that = new el8.appanalytics.ReportTab({
        showOnLoad: false,
        trigger: $('.report-title[_section="mu-population"]'),
        container: container,
        formSpec: {
            container: $('form', container),
            buttonElt: $('.mu-population-buttons', container),
            fields: [
                {
                    name: 'lastSeenFilter',
                    type: 'select',
                    selector: ':input[name="lastSeenFilter"]',
                    changeFn: function() {
                        var form = that._form;
                        if (form.getVal('lastSeenFilter')) {
                            form.enableField('filterDaysSince');
                        } else {
                            form.disableField('filterDaysSince');
                        }
                    }
                },
                {
                    name: 'filterDaysSince',
                    type: 'select',
                    selector: ':input[name="filterDaysSince"]',
                    changeFn: function() {
                        var form = that._form;
                        if (form.getVal('filterDaysSince') === '0') {
                            $('.custom-start-date', container).show();
                            $('.custom-end-date', container).show();
                        } else {
                            $('.custom-start-date', container).hide();
                            $('.custom-end-date', container).hide();
                            form.setVal('startDate', '');
                            form.setVal('endDate', '');
                        }
                    }
                },
                {
                    name: 'startDate',
                    selector: ':input[name="startDate"]',
                    infoText: 'start date',
                    datePickerOpts: {
                        // 6-hour offset to allow for nightly jobs to
                        // run after midnight
                        maxDate: el8.service.tz.nowPlusHours(6).zeroTime(),
                        minDate: el8.service.tz.newTzDate(2009, 1, 1)
                    }
                },
                {
                    name: 'endDate',
                    selector: ':input[name="endDate"]',
                    infoText: 'end date',
                    datePickerOpts: {
                        // 6-hour offset to allow for nightly jobs to
                        // run after midnight
                        maxDate: el8.service.tz.nowPlusHours(6).zeroTime(),
                        minDate: el8.service.tz.newTzDate(2009, 1, 1)
                    }
                },
                {
                    name: 'physician',
                    type: 'select',
                    selector: ':input[name="physician"]'
                },
                {
                    name: 'period',
                    type: 'select',
                    selector: ':input[name="period"]'
                },
                {
                    name: 'minAge',
                    type: 'input',
                    infoText: 'min age...',
                    selector: ':input[name="minAge"]',
                    validate: {
                        number: true
                    }
                },
                {
                    name: 'maxAge',
                    type: 'input',
                    infoText: 'max age...',
                    selector: ':input[name="maxAge"]',
                    validate: {
                        number: true
                    }
                },
                {
                    name: 'gender',
                    type: 'select',
                    selector: ':input[name="gender"]'
                },
                {
                    name: 'race',
                    type: 'select',
                    selector: ':input[name="race"]'
                },
                {
                    name: 'ethnicity',
                    type: 'select',
                    selector: ':input[name="ethnicity"]'
                },
                {
                    name: 'prefLanguage',
                    type: 'select',
                    selector: ':input[name="prefLanguage"]',
                    chosenOpts: {
                        allow_single_deselect: true
                    }
                },
                {
                    name: 'prefContactMethod',
                    type: 'select',
                    selector: ':input[name="prefContactMethod"]'
                },
                /* passport checkboxes */
                {
                    name: 'USED',
                    selector: ':input[name="USED"]'
                },
                {
                    name: 'INVITED',
                    selector: ':input[name="INVITED"]'
                },
                {
                    name: 'NOT_INVITED',
                    selector: ':input[name="NOT_INVITED"]'
                },
                {
                    name: 'logicalOperator'
                },
                {
                    name: 'minHcc',
                    type: 'input',
                    infoText: 'min HCC...',
                    selector: ':input[name="minHcc"]',
                    validate: {
                        number: true
                    }
                },
                {
                    name: 'maxHcc',
                    type: 'input',
                    infoText: 'max HCC...',
                    selector: ':input[name="maxHcc"]',
                    validate: {
                        number: true
                    }
                }
                //item 2 above - modify when adding new filters
            ],
            multifieldListeditorSpecs: multifieldSpecs,
            buttons: [
                ['generate', 'Search', function() {
                    page = 0;
                    orderBy = null;
                    if (that.validate()) {
                        destroyPassportTooltips(); // remove stray DOM elements
                        that.resetPatientSelection();
                        that.load();
                    }
                }, true],
                ['clear', 'Clear Filters', function() { that.reset(); }, false]
            ],
            validationOpts: el8.util.validate.standardOpts
        },
        initFn: function() {

            that._form.setVal('physician', el8.data.currUser.getStaffId());

            that._form.disableField('filterDaysSince');

            el8.uiwidget.collapsible({
                container: $('.mu-demog-extras', container),
                triggerElt: $('.mu-demog-extras-trigger', container),
                statusElt: $('.mu-demog-extras-trigger', container),
                statusTextCollapse: "show more demographics options",
                statusTextExpand: "hide more demographics options",
                // Make sure that the mu-demog-extras section is collapsed after prefLanguage is loaded
                // (otherwise, prefLanguage gets all wonky)
                isCollapsed: true
            });

            container.on('click', '.add-entry-trigger',  function(e) {
                var group = $(this).data('group');
                var mle = that._form.getMultifieldListeditor(group);
                mle.addNewEntry();

            }).on('click', '.remove-entry-trigger',  function(e) {
                var $this = $(this);
                var index = $this.data('index');
                var group = $this.data('group');
                var mle = that._form.getMultifieldListeditor(group);
                mle.removeEntry(index);

            }).on('click', '.sort-trigger',  function(e) {
                var sortCol = $(this).attr('_type');
                if (sortCol === orderBy || !orderBy) {
                    orderBy = '-' + sortCol;
                } else if ('-' + sortCol === orderBy) {
                    orderBy = sortCol;
                } else {
                    orderBy = $(this).attr('_type');
                }
                page = 0;
                that.load();

            }).on('click', '.next-page-trigger',  function(e) {
                page += 1;
                that.load();

            }).on('click', '.prev-page-trigger',  function(e) {
                page = Math.max(page-1, 0);
                that.load();

            }).on('click', '.goto-page-trigger',  function(e) {
                page = parseInt($(this).attr('_page'), 10);
                that.load();
            }).on('click', '.download-csv',  function(e) {
                that.downloadCSV();
            }).on('click', '.send-bulk-letters',  function(e) {
                that.loadPatientsForBulkLetters(function(query, data) {
                    el8.appanalytics.dialog.bulkLetters.setProps({
                        query: query,
                        patients: data.selected_patients,
                        queryLogId: data.query_log_id,
                        totalPatientsFromQuery: data.total_patients_from_query
                    });
                    el8.appanalytics.dialog.bulkLetters.show();
                    el8.appanalytics.dialog.bulkLetters.setTitle(
                      'Send Bulk Letter – ' +
                      data.selected_patients.length +
                      (data.selected_patients.length === 1 ? ' patient' : ' patients') +
                      ' selected'
                    );
                });

            }).on('click', '.patients-select-all',  function(e) {

                // if we have selected all previously, and unchecked SOME
                // patients, clicking select all will select every patients
                if (that.getHasSelectedAll()) {
                    if (Object.keys(that.getToggledPatientIds()).length) {
                    that.clearToggledPatientIds();
                    } else {
                        that.setHasSelectedAll(false);
                    }
                } else {
                    that.setHasSelectedAll(true);
                    that.clearToggledPatientIds();
                }

                that.updatePatientCheckboxState();
                that.updateSelectedPatientInfo();
            });

            el8.appanalytics.util.initCollapsibleFilters(container);

        },
        loadFn: function(callbackFn, onCompleteFn) {
            var physicianId = that._form.getVal('physician') || null;
            var query = constructQuery();
            var displayFilters = prepareFiltersForDisplay(query.and_filters, query.or_filters);

            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('muPopulation', [physicianId]),
                data: {'data': JSON.stringify(query), 'old_format': true },
                success: function(data) {
                    data['page'] = page;
                    data['panelName'] = $('option:selected', that._form.getInputField('physician')).text();
                    data['displayFilters'] = displayFilters;
                    $('.report-contents', container).html(
                        el8.template.appanalytics.reports.muPopulation.results(data)
                    );

                    container.off('change', '.patient-checkbox');
                    container.on('change', '.patient-checkbox',  function(e) {
                        var $checkbox = $(e.currentTarget);
                        var patientId = $checkbox.attr('data-patient');
                        that.togglePatientId(patientId);
                    });

                    // Set the sort arrows appropriately
                    $('.sort-trigger', container).each(function(index, elt) {
                        if (orderBy === '-' + $(elt).attr('_type')) {
                            $('.arrow-icon', $(elt)).addClass('downArrowIcon');
                        } else {
                            $('.arrow-icon', $(elt)).addClass('upArrowIcon');
                        }
                    });
                    // Setup passport icon tooltips
                    addPassportTooltip('.passport-no');
                    addPassportTooltip('.passport-invited');
                    addPassportTooltip('.passport-yes');

                    that.setTotalRecords(data['total_records']);
                    that.updateSelectedPatientInfo();
                    that.updatePatientCheckboxState();

                    if (callbackFn) { callbackFn(); }
                },
                error_override: function() {
                    displayError();
                    if (callbackFn) { callbackFn(); }
                },
                complete: function() {
                    if (onCompleteFn) { onCompleteFn(); }
                }
            });
        }
    });

    that.loadPatientsForBulkLetters = function(callbackFn) {
        var physicianId = that._form.getVal('physician') || null;
        var query = constructQuery();
        var displayFilters = prepareFiltersForDisplay(query.and_filters, query.or_filters);

        // add the patient selection pieces
        query['has_selected_all'] = that.getHasSelectedAll();
        // converts list of patient IDs into int, since that's what backend
        // uses to make comparison
        query['toggled_patient_ids'] = that.getToggledPatientIds().map(Number);

        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('muPopulation', [physicianId]),
            data: JSON.stringify(query),
            success: function(data) {
                if (callbackFn) {callbackFn(query, data); }
            }
        });
    };


    that.downloadCSV = function() {
        var physicianId = that._form.getVal('physician') || null;
        var query = constructQuery();
        var displayFilters = prepareFiltersForDisplay(query.and_filters, query.or_filters);
        var filterText = displayFiltersAsText(displayFilters);
        el8.appanalytics.dialog.patientListCSV.show(physicianId, query, filterText);
    };

    that.reset = function() {
        // Clears this specific search
        destroyPassportTooltips(); // remove stray DOM elements
        $('.report-contents', container).empty();
        that._form.reset();
        page = 0;
        orderBy = null;
    };

    that.validate = function() {
        var validated = that._form.isValid();
        if (!validated) { displayError(); }
        return validated;
    };

    that.clearToggledPatientIds = function() {
        window.sessionStorage.setItem('patientList_toggledPatientIds', '');
    };

    that.getToggledPatientIds = function() {
        var str = window.sessionStorage.getItem('patientList_toggledPatientIds');
        return str ? str.split(',') : [];
    };

    that.hasToggledPatientId = function(patientId) {
        var patientIds = that.getToggledPatientIds();
        return (patientIds.indexOf(patientId) !== -1);
    };

    that.setPatientIdToggles = function(patientId, toggled) {
        var patientIds = that.getToggledPatientIds();
        var patientPosition = patientIds.indexOf(patientId);

        if (toggled && patientPosition === -1) {
            patientIds.push(patientId);
        } else if (!toggled && patientPosition !== -1) {
            patientIds.splice(patientPosition, 1);
        }
        window.sessionStorage.setItem('patientList_toggledPatientIds', patientIds.join(','));
    };

    that.resetPatientSelection = function() {
        window.sessionStorage.removeItem('patientList_toggledPatientIds');
        window.sessionStorage.removeItem('patientList_hasSelectedAll');
        window.sessionStorage.removeItem('patientList_totalRecords');
    };

    that.getHasSelectedAll = function() {
        return (window.sessionStorage.getItem('patientList_hasSelectedAll') === 'true');
    };

    that.setHasSelectedAll = function(selected) {
        window.sessionStorage.setItem('patientList_hasSelectedAll', selected);
    };

    that.getTotalRecords = function() {
        return window.sessionStorage.getItem('patientList_totalRecords');
    };

    that.setTotalRecords = function(total) {
        window.sessionStorage.setItem('patientList_totalRecords', total);
    };

    // for processing a select/deselecting a single patient checkbox
    that.togglePatientId = function(patientId) {
        that.setPatientIdToggles(patientId, !that.hasToggledPatientId(patientId));
        that.updateSelectedPatientInfo();
    };

    that.updateSelectedPatientInfo = function() {
        var toggled = that.getToggledPatientIds().length;
        var count = that.getHasSelectedAll() ? (that.getTotalRecords() - toggled) : toggled;
        $("#patientsSelectedInfo").text(count + ' out of ' +  that.getTotalRecords() + ' Patients Selected');
        $(".send-bulk-letters").prop("disabled", !count);

        // we only toggle button to "Deselect All" if we are currently
        // toggled all and don't have any that we've toggled off.
        if (that.getHasSelectedAll() && toggled === 0) {
            $(".patients-select-all").text('Deselect All');
        } else {
            $(".patients-select-all").text('Select All');
        }
    };

    that.updatePatientCheckboxState = function() {
        var patientIds = that.getToggledPatientIds();
        var hasSelectedAll = that.getHasSelectedAll();

        $('input:checkbox.patient-checkbox').each(function() {
            var thisPatientId = $(this).data('patient');

            if (hasSelectedAll) {
                if (patientIds.indexOf(thisPatientId) === -1) {
                    $(this).prop('checked', true);
                } else {
                    $(this).prop('checked', false);
                }
            } else {
                if (patientIds.indexOf(thisPatientId) === -1) {
                    $(this).prop('checked', false);
                } else {
                    $(this).prop('checked', true);
                }
            }
        })
    };

    /* =============================
     *  Helper Methods
     * ============================= */
    /**
     * This function changes the filters from a format useful for the server
     * (where each problem, allergy, etc. is a separate filter) to one useful for the
     * Soy template (where we divide positive and negative filters and have a list
     * of problems,list of allergies, etc.).
     * It also does minimal string formatting (for operators and age range)
     */
    function prepareFiltersForDisplay(andFilters, orFilters) {
        var displayFilters = {};

        var flattenSection = function(filters) {
            var positiveList = [];
            var negativeList = [];

            var groups = {
                'problems': [],
                'medications': [],
                'allergies': [],
                'labs': [],
                'vaccines': [],
                'tags': [],
                'doctags': [],
                'cptcodes': []
            };
            var passportStatuses = [];
            var orderStatuses = [];
            var minHcc = null;
            var maxHcc = null;
            for (var i=0; i < filters.length; i++) {
                var f = filters[i];
                switch(f.type) {
                    case 'base':
                        // no negation for the base section
                        positiveList = positiveList.concat(flattenBaseFilter(f));
                        break;
                    case 'problems':
                    case 'medications':
                    case 'allergies':
                    case 'vaccines':
                    case 'tags':
                    case 'doctags':
                        // we'll turn all these groups into positive/negative lists below
                        groups[f.type].push({str: f.params.search_term, negated: f.negated});
                        break;
                    case 'cptcodes':
                        groups[f.type].push({
                            str: f.params.search_term,
                            negated: f.negated,
                            start_date: f.params.start_date,
                            end_date: f.params.end_date
                        });
                        break;
                    case 'labs':
                        var labString = el8.template.appanalytics.reports.muPopulation.displayLab(f.params);
                        groups['labs'].push({
                            str: labString,
                            negated: f.negated
                        });
                        break;
                    case 'passport':
                        passportStatuses = f.params.invite_statuses;
                        break;
                    case 'outstanding_orders':
                        orderStatuses = f.params.resolution_states;
                        break;
                    case 'hcc':
                        minHcc = f.params.min_hcc;
                        maxHcc = f.params.max_hcc;
                        break;
                }
            }
            // no negation for the passport section
            if (passportStatuses.length) {
                var formattedList = passportStatuses.map(function(status) {
                    var formatFn = el8.template.appanalytics.reports.muPopulation.passportStatusInfoText;
                    return formatFn({status: status});
                });
                positiveList.push({
                    name: 'Passport Status in',
                    list: formattedList
                });
            }

            // no negation for HCC
            if (minHcc || maxHcc) {
                positiveList.push({
                    name: 'HCC',
                    noFilterPrefix: true,
                    list: [minHcc + ' to ' + maxHcc]
                });
            }

            if (orderStatuses.length) {
                var formattedList = orderStatuses.map(function(status) {
                    var formatFn = el8.template.appanalytics.reports.muPopulation.orderStatusInfoText;
                    return formatFn({status: status});
                });
                positiveList.push({
                    name: 'Order Status in',
                    list: formattedList
                });
            }

            // turning the groups into lists
            var mleSections = [ ['problems', 'Problem(s)'], ['medications', 'Medication(s)'],
                ['allergies', 'Allergies'], ['vaccines', 'Vaccine(s)'], ['tags', 'Patient Tag(s)'],
                ['doctags', 'Document Tag(s)'], ['cptcodes', 'CPT Code(s)'], ['labs', 'Lab(s)'] ];
            mleSections.forEach(function(sectionSpec) {
                var list = groups[sectionSpec[0]];
                var name = sectionSpec[1];

                if (list.length) {
                    list.forEach(function(item) {
                        if (item.negated !== true) {
                            // make sure every item is true or false
                            item.negated = false;
                        }
                    });
                    var splitList = _.groupBy(list, 'negated');

                    if (splitList[false] && splitList[false].length) {
                        positiveList.push({
                            name: name,
                            list: splitList[false].map(function(item) { return item.str; })
                        });
                    }
                    if (splitList[true] && splitList[true].length) {
                        negativeList.push({
                            name: name,
                            list: splitList[true].map(function(item) { return item.str; })
                        });
                    }
                }
            });
            // item 4 above - modify when adding new filters
            return {
                positiveList: positiveList,
                negativeList: negativeList,
                hasEntries: Boolean(positiveList.length + negativeList.length)
            };
        };
        displayFilters.andFilters = flattenSection(andFilters);
        displayFilters.orFilters = flattenSection(orFilters);

        return displayFilters;
    }

    function flattenBaseFilter(baseFilter) {
        // noFilterPrefix because we don't want to say
        // "patients who meet all of these criteria: _have_ Gender: X",
        // just "criteria: Gender: X" for these demographics
        var flattenedSection = [];
        if (baseFilter.params['min_age'] && baseFilter.params['max_age']) {
            flattenedSection.push({
                name: 'Ages',
                noFilterPrefix: true,
                list: [baseFilter.params['min_age'] + ' to ' + baseFilter.params['max_age']]
            });
        }
        if (baseFilter.params.gender) {
            flattenedSection.push({
                name: 'Gender',
                noFilterPrefix: true,
                list: [baseFilter.params.gender]
            });
        }
        if (baseFilter.params.race) {
            var raceName = el8.data.races[baseFilter.params.race-1][1];
            flattenedSection.push({
                name: 'Race',
                noFilterPrefix: true,
                list: [raceName]
            });
        }
        if (baseFilter.params.ethnicity) {
            var ethnicityName = el8.data.ethnicities[baseFilter.params.ethnicity-1][1];
            flattenedSection.push({
                name: 'Ethnicity',
                noFilterPrefix: true,
                list: [ethnicityName]
            });
        }
        if (baseFilter.params.pref_language) {
            flattenedSection.push({
                name: 'Preferred Language',
                noFilterPrefix: true,
                list: [baseFilter.params.pref_language]
            });
        }
        if (baseFilter.params.pref_contact_method) {
            flattenedSection.push({
                name: 'Preferred Contact Method',
                noFilterPrefix: true,
                list: [baseFilter.params.pref_contact_method]
            });
        }
        return flattenedSection;
    }

    function displayFiltersAsText(displayFilters) {
        var filterHtml = el8.template.appanalytics.reports.muPopulation.filtersAsHtml(displayFilters);
        var filterText = $('<p>'+filterHtml+'</p>').text();
        return filterText;
    }

    function constructQuery() {
        var form = that._form;
        // var filters = [];
        var andFilters = [];
        var orFilters = [];

        // The base filter will always go in the AND section
        addBaseFilterToQuery(andFilters);

        var minHcc = form.getVal('minHcc');
        var maxHcc = form.getVal('maxHcc');

     // HCC filters will always go in the AND section
        if (minHcc || maxHcc) {
            andFilters.push({
                    type: 'hcc',
                    params: {
                        'min_hcc': minHcc,
                        'max_hcc': maxHcc
                    }});
        }

        // So do passport status (because we don't expect people to want to filter
        // for people on a medication OR with a passport status... passport status is
        // going to be an initial criterion)
        if (form.getVal('USED') || form.getVal('INVITED') || form.getVal('NOT_INVITED')) {
            var invite_statuses = [];
            if (form.getVal('USED')) { invite_statuses.push('USED'); }
            if (form.getVal('INVITED')) { invite_statuses.push('INVITED'); }
            if (form.getVal('NOT_INVITED')) { invite_statuses.push('NOT_INVITED'); }
            andFilters.push({
                type: 'passport',
                params: { invite_statuses: invite_statuses }
            });
        }

        if (el8Globals.FEATURES['BiDiLabs']) {
            // Outstanding Orders
            var resolution_states = [];
            if (form.getVal('orderstatus-outstanding')) { resolution_states.push('outstanding'); }
            if (form.getVal('orderstatus-cancelled')) { resolution_states.push('cancelled'); }
            if (form.getVal('orderstatus-resolved')) { resolution_states.push('resolved'); }
            if (form.getVal('orderstatus-unknown')) { resolution_states.push('unknown'); }
            if (resolution_states.length) {
                andFilters.push({
                    type: 'outstanding_orders',
                    params: { resolution_states:resolution_states }
                });
            }
        }

        // check whether these filters are going to be ANDed or ORed
        var clinicalFilters = (form.getVal('logicalOperator') === 'AND') ?
            andFilters : orFilters;

        // extract labs separately from the other MLEs because we want to do validation
        var labIsNonEmpty = function(labEntry) {
            return (labEntry.name && labEntry.operator && !el8.util.isNone(labEntry.value));
        };
        addFiltersFromMultifield('labs', clinicalFilters, labIsNonEmpty);

        var MLE_NAMES = ['problems', 'medications', 'allergies', 'vaccines', 'tags', 'doctags', 'cptcodes'];
        MLE_NAMES.forEach(function(groupName) {
            addFiltersFromMultifield(groupName, clinicalFilters);
        });
        //item 3 above - modify when adding new filters

        var data = {
            'and_filters': andFilters,
            'or_filters': orFilters,
            'page': page,
            'limit': LIMIT
        };
        if (orderBy) {
            data['order_by'] = orderBy;
        }
        return data;
    }
    function addBaseFilterToQuery(filtersList) {
        var form = that._form;

        var minAge = form.getVal('minAge');
        var maxAge = form.getVal('maxAge');
        var gender = form.getVal('gender');
        var race = form.getVal('race');
        var ethnicity = form.getVal('ethnicity');
        var prefLanguage = form.getVal('prefLanguage');
        var prefContactMethod = form.getVal('prefContactMethod');

        var lastSeenFilter = form.getVal('lastSeenFilter');
        var filterDaysSince = form.getVal('filterDaysSince');
        var startDate = form.getVal('startDate');
        var endDate = form.getVal('endDate');

        var f = {
            type: 'base',
            params: {}
        };
        if (minAge && maxAge) {
            f.params['min_age'] = minAge;
            f.params['max_age'] = maxAge;
        }
        if (gender) { f.params.gender = gender; }
        if (race) { f.params.race = race; }
        if (ethnicity) { f.params.ethnicity = ethnicity; }
        if (prefLanguage) { f.params.pref_language = prefLanguage; }
        if (prefContactMethod) { f.params.pref_contact_method = prefContactMethod; }

        if (lastSeenFilter) {
            f.params.last_seen_filter = lastSeenFilter;
            f.params.last_seen_days_since = filterDaysSince;
            if (startDate) { f.params.last_seen_start_date = startDate; }
            if (endDate) { f.params.last_seen_end_date = endDate; }
        }

        if (!_.isEmpty(f.params)) {
            filtersList.push(f);
        }
    }
    function addFiltersFromMultifield(groupName, filtersList, validationFn) {
        var entries = that._form.getMultifieldListeditor(groupName).getAllEntries();

        if (!validationFn) {
            // by default, make sure there's a search term
            validationFn = function(entry) { return entry.search_term; };
        }

        entries.forEach(function(entry) {
            if (validationFn(entry)) {
                // Our API makes 'negated' a peer to 'type' and 'params',
                // but it's easier to collect it in the dict from each MLE,
                // so we'll hoist it up here:
                var negated = entry['negated'] || false;
                delete entry['negated'];
                filtersList.push({
                    type: groupName,
                    negated: negated,
                    params: entry
                });
            }
        });
    }
    // just exposed for unit test use
    that._constructQuery = constructQuery;
    that._prepareFiltersForDisplay = prepareFiltersForDisplay;
    that._displayFiltersAsText = displayFiltersAsText;

    function addInstructionsToInfoDiv(cb_args) {
        var infoText = cb_args.infoDiv.text();
        if (infoText) {
            if (!cb_args.searchString) { infoText = ''; }
            cb_args.infoDiv.text(infoText +
                ' Tab or click off to just search for the text "' + cb_args.searchString + '".');
        }
    }

    function getNegatableMultifieldOpts(opts) {
        var groupName = opts.groupName;
        return {
            groupName: groupName,
            listContainer: $('#add-'+groupName+'-list', container),
            templateFn: el8.template.appanalytics.reports.muPopulation.negatableInput,
            templateArgs: { groupName: groupName },
            fieldSpecFn: function(index) {
                var fields = [
                    {
                        name: groupName+'_'+index,
                        infoText: 'Add '+groupName+'...',
                        newMindreader: true,
                        mindreaderOpts: opts.mindreaderOpts
                    },
                    {
                        name: groupName+'Negation_'+index,
                        castToBool: true
                    }
                ];
                return fields;
            },
            getEntryMapFn: function(mle, index) {
                return {
                    search_term: mle.getVal(groupName, index),
                    negated: mle.getVal(groupName+'Negation', index)
                };
            }
        };
    }

    // provides a field w/ negatable field and start/end date selectors
    function getNegatableDateRangeMultifieldOpts(opts) {
        var groupName = opts.groupName;
        return {
            groupName: groupName,
            listContainer: $('#add-'+groupName+'-list', container),
            templateFn: el8.template.appanalytics.reports.muPopulation.negatableWithDateRangeInput,
            templateArgs: { groupName: groupName },
            fieldSpecFn: function(index) {
                var fields = [
                    {
                        name: groupName+'_'+index,
                        infoText: 'Add '+groupName+'...',
                        newMindreader: true,
                        mindreaderOpts: opts.mindreaderOpts
                    },
                    {
                        name: groupName+'StartDate_'+index
                    },
                    {
                        name: groupName+'EndDate_'+index
                    },
                    {
                        name: groupName+'Negation_'+index,
                        castToBool: true
                    }
                ];
                return fields;
            },
            customInitEntryFn: function($entry, index) {
                $('.dateStart', $entry).el8_datePicker(
                    { maxDate: el8.service.tz.today() },
                    { infoText: 'select date...' }
                );
                $('.dateEnd', $entry).el8_datePicker(
                    { maxDate: el8.service.tz.today() },
                    { infoText: 'select date...' }
                );
            },
            getEntryMapFn: function(mle, index) {
                return {
                    search_term: mle.getVal(groupName, index),
                    negated: mle.getVal(groupName+'Negation', index),
                    start_date: mle.getVal(groupName+'StartDate', index),
                    end_date: mle.getVal(groupName+'EndDate', index)
                };
            }
        };
    }

    function displayError() {
        $('.report-contents', container).html(
            el8.template.appanalytics.reports.muPopulation.results({ error: true })
        );
    }

    function addPassportTooltip(iconSelector) {
        var passportStatus;
        switch (iconSelector) {
            case '.passport-no':
                passportStatus = 'NOT_INVITED';
                break;
            case '.passport-invited':
                passportStatus = 'INVITED';
                break;
            case '.passport-yes':
                passportStatus = 'USED';
                break;
            default:
                passportStatus = 'NOT_INVITED';
        }
        var hoverMsg = el8.template.appanalytics.reports.muPopulation.passportStatusInfoText({status: passportStatus});
        el8.service.tooltip.create({
            anchor: $(iconSelector),
            text: hoverMsg
        });
    }

    function destroyPassportTooltips() {
        var $tooltips = $('.passport-no,.passport-invited,.passport-yes');
        el8.service.tooltip.destroy($tooltips);
    }

    return that;
};
